// Andar Bahar — frontend GameModule. Dark-launch: games.is_locked=1.
import type { GameModule } from '../types';
import Page from './Page';

const andarBahar: GameModule = {
  id: 'andar_bahar',
  displayName: 'Andar Bahar',
  tag: 'Casino',
  theme: { gradient: 'from-pink-500 to-rose-700', emoji: '🃟', logo: '/games/andar_bahar/Logo.png' },
  orientation: 'portrait',
  adminIcon: 'style',
  adminTheme: {
    headerFrom: 'from-emerald-900', headerTo: 'to-rose-800',
    ring: 'ring-rose-400', accent: 'bg-rose-600', accentHover: 'hover:bg-rose-500',
    dot: 'bg-rose-400', softBg: 'bg-rose-900/30', rangeAccent: 'accent-rose-500',
    badgeClasses: 'bg-rose-600/20 text-rose-300 border-rose-600/30',
  },
  Page,
};

export default andarBahar;
